export default __webpack_public_path__ + "static/media/approach-S.27c3c254.jpg";